/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	AsyncTransitionHomeRenderer,
	AsyncWelcomeModalRenderer,
} from '@jira/platform__layouts-eoc-changeboarding-layout/src/index.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import {
	composeLayouts,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';

export const homepageLayout: Layout = composeLayouts(globalLayout, {
	// both of the components are wrapped with componentWithCondition
	globalComponents: [AsyncTransitionHomeRenderer, AsyncWelcomeModalRenderer],
});
